/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";
import styled from "@emotion/styled";
import { Alerts } from "@components/common/AlertModal";
import axios, { AxiosError } from "axios";
import { useSelector } from "react-redux";
import { RootState } from "../store/reducer";
import { useParams } from "react-router-dom";
import { colors, Title1 } from "@utils/ui_palette";
import { rgba } from "emotion-rgba";
import { calculatePercentage, convertBirth } from "@utils/help";
import { IoDocumentTextOutline } from "react-icons/io5";
import { Link } from "react-router-dom";

interface IUser {
  admin_gb: number;
  adult: number;
  birth: string;
  createdAt: string;
  foreigner: number;
  gender: number;
  id: number;
  imp_unique_key: string;
  login_id: string;
  m_rec_gb: number;
  phone_num: string;
  useremail: string;
  username: string;
  vip_gb: number;
  profiles: IProfile[];
}

interface IProfile {
  birth: string;
  createdAt: string;
  id: number;
  nick: string;
  thumb_imageprofile: string;
  updatedAt: string;
  user_id: number;
}

interface IReport {
  createdAt: string;
  grade_type: number;
  id: number;
  memo: null;
  paper_id: number;
  perfect_score: number;
  profile_id: number;
  save_at: string;
  save_gb: number;
  total_score: number;
  updatedAt: string;
}

function UserDetail() {
  const { id } = useParams();
  const accessToken = useSelector(
    (state: RootState) => state.user.userInfo.accessToken
  );
  const [userInfo, setUserInfo] = useState<null | IUser>(null);
  const [currentTab, setCurrentTab] = useState<null | IProfile>(null);
  const [report, setReport] = useState<null | IReport[]>(null);
  const [reportTotal, setReportTotal] = useState<number>(0);
  const [reportAverage, setReportAverage] = useState<number>(0);
  const [, setReportTotalPage] = useState<0>(0);

  const changeTab = useCallback((tab: IProfile) => {
    setCurrentTab(tab);
  }, []);

  const getUser = useCallback(async () => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API}/admin/users/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      setUserInfo(data.user);
      setCurrentTab(data.user.profiles[0]);
    } catch (error) {
      const errorResponse = (error as AxiosError).response;

      if (errorResponse && (errorResponse.data as any).message) {
        Alerts.show({
          title: (errorResponse.data as any).message,
        });
      }
    }
  }, [accessToken, id]);

  const setAverage = useCallback(
    (quater: IReport[]) => {
      const percScore = quater.map((data) => {
        return calculatePercentage(data.total_score, data.perfect_score);
      });

      const result = percScore.reduce((prev, cur) => {
        return prev + cur;
      }, 0);

      setReportAverage(Math.floor(result / percScore.length));
    },
    [report]
  );

  const getProfileReport = useCallback(async () => {
    if (!currentTab) {
      return;
    }
    const formData = {
      profile_id: currentTab.id,
    };
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API}/accessement/list?page=1`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      setReport(data.quater_list);
      setAverage(data.quater_list);
      setReportTotalPage(data.total_page);
      setReportTotal(data.total);
      setCurrentTab(data.user.profiles[0]);
    } catch (error) {
      const errorResponse = (error as AxiosError).response;

      if (errorResponse && (errorResponse.data as any).message) {
        Alerts.show({
          title: (errorResponse.data as any).message,
        });
      }
    }
  }, [
    accessToken,
    currentTab,
    setReport,
    setReportTotalPage,
    setReportTotal,
    setCurrentTab,
  ]);

  useEffect(() => {
    getProfileReport();
    console.log("123");
  }, [currentTab]);

  useEffect(() => {
    getUser();
  }, [getUser]);

  return (
    <Container>
      <TitleBox>
        <Title1 align="left">User Detail</Title1>
      </TitleBox>
      {userInfo && (
        <Panel>
          <PanelBody>
            {currentTab && (
              <>
                {userInfo.id !== 18 && (
                  <TabBox>
                    {userInfo.profiles.map((profile) => (
                      <Tab
                        key={`${profile.nick}-${profile.id}`}
                        lenght={2}
                        active={currentTab.id === profile.id}
                        onClick={() => changeTab(profile)}
                      >
                        {profile.nick}
                      </Tab>
                    ))}
                  </TabBox>
                )}
                <ProfileInfoBox>
                  <ProfileImageBox>
                    <ProfileImage src={currentTab.thumb_imageprofile} />
                  </ProfileImageBox>
                  <Title1 marginTop={20}>{currentTab.nick}</Title1>

                  <Panel>
                    <UserInfoBox>
                      <InfoTitle>Birth: </InfoTitle>
                      <Info>{convertBirth(currentTab.birth)}</Info>
                    </UserInfoBox>
                    <UserInfoBox>
                      <InfoTitle>Last Update: </InfoTitle>
                      <Info>{currentTab.updatedAt.split("T")[0]}</Info>
                    </UserInfoBox>
                    <UserInfoBox>
                      <InfoTitle>Assessment Report: </InfoTitle>
                      <Info>
                        <InfoBold>{reportTotal} Cases</InfoBold>
                      </Info>
                    </UserInfoBox>
                    <UserInfoBox>
                      <InfoTitle>Assessment Average: </InfoTitle>
                      <Info>
                        <InfoBold>{reportAverage || 0}%</InfoBold>
                      </Info>
                    </UserInfoBox>
                  </Panel>
                </ProfileInfoBox>
              </>
            )}
          </PanelBody>
          <PanelBody>
            {userInfo.id === 18 && currentTab && (
              <SideTabBox>
                <TabBox>
                  {userInfo.profiles.map((profile) => (
                    <Tab
                      key={`${profile.nick}-${profile.id}`}
                      lenght={2}
                      active={currentTab.id === profile.id}
                      onClick={() => changeTab(profile)}
                    >
                      {profile.nick}
                    </Tab>
                  ))}
                </TabBox>
              </SideTabBox>
            )}
            {userInfo.id !== 18 && currentTab && (
              <>
                <UserInfoBox>
                  <InfoTitle>Name: </InfoTitle>
                  <Info>{userInfo.username}</Info>
                </UserInfoBox>
                <UserInfoBox>
                  <InfoTitle>Login ID: </InfoTitle>
                  <Info>{userInfo.login_id}</Info>
                </UserInfoBox>
                <UserInfoBox>
                  <InfoTitle>Certification Key: </InfoTitle>
                  <Info>{userInfo.imp_unique_key}</Info>
                </UserInfoBox>
                <UserInfoBox>
                  <InfoTitle>Email: </InfoTitle>
                  <Info>{userInfo.useremail}</Info>
                </UserInfoBox>
                <UserInfoBox>
                  <InfoTitle>Phone Number: </InfoTitle>
                  <Info>{userInfo.phone_num}</Info>
                </UserInfoBox>
                <UserInfoBox>
                  <InfoTitle>Birth: </InfoTitle>
                  <Info>{userInfo.birth}</Info>
                </UserInfoBox>
                <UserInfoBox>
                  <InfoTitle>Membership Type: </InfoTitle>
                  <Info>{userInfo.vip_gb === 0 ? "General" : "Premium"}</Info>
                </UserInfoBox>
                <UserInfoBox>
                  <InfoTitle>Marketing Consent: </InfoTitle>
                  <Info>{userInfo.m_rec_gb === 2 ? "Yes" : "No"}</Info>
                </UserInfoBox>
                <UserInfoBox>
                  <InfoTitle>Gender: </InfoTitle>
                  <Info>{userInfo.gender === 0 ? "Man" : "Woman"}</Info>
                </UserInfoBox>
                <UserInfoBox>
                  <InfoTitle>Foreigner: </InfoTitle>
                  <Info>{userInfo.foreigner === 0 ? "No" : "Yes"}</Info>
                </UserInfoBox>
                <UserInfoBox>
                  <InfoTitle>Adult: </InfoTitle>
                  <Info>{userInfo.admin_gb === 1 ? "Yes" : "No"}</Info>
                </UserInfoBox>
                <UserInfoBox>
                  <InfoTitle>Admin Type: </InfoTitle>
                  <Info>
                    {userInfo.admin_gb === 1 ? "Manager" : "General Member"}
                  </Info>
                </UserInfoBox>
              </>
            )}
          </PanelBody>
        </Panel>
      )}

      {report && report.length > 0 && (
        <Panel>
          <ReportCardGroup>
            {report.map((data) => (
              <Link
                to={`/assessment/${data.id}?grade_type=${data.grade_type}`}
                key={`report-${data.id}`}
                target="_blank"
              >
                <RportCardItem>
                  <IoDocumentTextOutline size={100} />
                  <ReportInfo>
                    <ReportTitle>
                      <Title1 align="left">
                        Level {data.grade_type.toString()[1]}
                      </Title1>

                      <ReportState>Done</ReportState>
                    </ReportTitle>
                    <ReportDescription>
                      <ReportUserBox>
                        <ReportBox>
                          <ReportDescTitle>Age</ReportDescTitle>
                          <ReportDescInfo>
                            .{data.grade_type.toString()[0]} years old
                          </ReportDescInfo>
                        </ReportBox>
                        <ReportBox>
                          <ReportDescTitle>Exam date</ReportDescTitle>
                          <ReportDescInfo>
                            {data.save_at.split("T")[0]}
                          </ReportDescInfo>
                        </ReportBox>
                      </ReportUserBox>
                      <ScoreBox>
                        <Score>{data.total_score}</Score>
                        <PerfectScore>/ {data.perfect_score}</PerfectScore>
                      </ScoreBox>
                    </ReportDescription>
                  </ReportInfo>
                </RportCardItem>
              </Link>
            ))}
          </ReportCardGroup>
        </Panel>
      )}
    </Container>
  );
}

const Container = styled.div`
  width: 1024px;
  padding: 20px;
`;

const TitleBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Panel = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 20px;
  border-radius: 12px;
  background-color: ${colors.White};
  border: 1px solid ${colors.Gray30};
  margin-top: 20px;
  box-shadow: 5px 5px 10px ${colors.Gray30};
`;

const PanelBody = styled.div`
  flex-basis: 50%;
  padding: 20px 40px;

  &:first-of-type {
    border-right: 1px solid ${colors.Gray30};
    padding: 20px 20px;
  }
`;

const UserInfoBox = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  flex-basis: 100%;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

const InfoTitle = styled.div`
  font-weight: 700;
  font-size: 18px;
`;

const Info = styled.div`
  padding-left: 10px;
  font-size: 18px;
`;

const SideTabBox = styled.div`
  max-height: 500px;
  overflow-x: scroll;
`;

const TabBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const Tab = styled.div<{ lenght: number; active: boolean }>`
  width: ${(props) => `calc(100% / ${props.lenght} - 5px)`};
  flex-basis: ${(props) => `calc(100% / ${props.lenght} - 5px)`};
  margin-bottom: 20px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.White};
  font-size: 18px;
  cursor: pointer;
  border: 2px solid
    ${(props) => (props.active ? colors.Primary50 : colors.Gray30)};
  border-radius: 12px;
  color: ${(props) => (props.active ? colors.Primary50 : colors.Gray30)};
  font-weight: ${(props) => (props.active ? 700 : 400)};

  &:hover {
    background-color: ${rgba(colors.Gray10, 0.5)};
  }
`;

const ProfileInfoBox = styled.div`
  margin-top: 40px;
`;

const ProfileImageBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto;
`;

const ProfileImage = styled("img")`
  width: 200px;
`;

const InfoBold = styled.div`
  font-size: 18px;
  color: ${colors.Primary50};
`;

const ReportCardGroup = styled.div`
  flex-basis: 100%;
`;

const RportCardItem = styled.div`
  border: 1px solid ${colors.Gray30};
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 20px;
  box-shadow: 5px 5px 10px ${colors.Gray30};
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.4s;
  background-color: ${colors.White};

  &:hover {
    transition: all 0.4s;
    transform: scale(1.02);
  }
`;

const ReportInfo = styled.div`
  padding-left: 20px;
  flex: 1;
`;

const ReportTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 20px;
`;

const ReportState = styled.div`
  color: ${colors.White};
  font-size: 18px;
  background-color: ${colors.Primary50};
  width: 150px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
`;

const ReportDescription = styled.div`
  padding-top: 20px;
  border-top: 1px solid ${colors.Gray30};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ReportBox = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

const ReportDescTitle = styled.div`
  flex-basis: 100px;
  font-size: 15px;
  color: ${colors.Gray50};
`;

const ReportDescInfo = styled.div`
  font-size: 15px;
  color: ${colors.Black};
`;

const ReportUserBox = styled.div`
  flex: 1;
`;

const ScoreBox = styled.div`
  display: flex;
  align-items: flex-end;
`;

const Score = styled.div`
  margin-right: 4px;
  font-size: 30px;
  font-weight: 700;
  color: ${colors.Primary50};
`;

const PerfectScore = styled.div`
  font-size: 30px;
  color: ${colors.Gray50};
`;

export default UserDetail;
